export default __webpack_public_path__ + "static/media/Map-Compilation.71e8b41a.jpg";